import React from 'react';
import { useMembershipShowContext } from '../../startup/MembershipShowApp';

function formatDateTime(v) {
  if (!v) return '';
  return new Date(v).toLocaleString('en-US', {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit',
  });
}

function formatCents(c) {
  return ((c || 0) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

function buildEvents(membership) {
  const events = [];

  if (membership.created_at) {
    events.push({
      at: membership.created_at,
      icon: 'fa-circle-plus',
      iconColor: 'var(--sl-text-brand)',
      label: 'Subscription created',
      detail: null,
    });
  }

  (membership.membership_invoices || []).forEach((inv) => {
    if (inv.refunded_at) {
      events.push({
        at: inv.refunded_at,
        icon: 'fa-rotate-left',
        iconColor: 'var(--sl-text-secondary)',
        label: 'Invoice refunded',
        detail: formatCents(inv.refunded_amount_cents),
      });
    }
    if (inv.status === 'paid') {
      events.push({
        at: inv.paid_at || inv.created_at,
        icon: 'fa-circle-check',
        iconColor: 'var(--sl-text-success)',
        label: 'Invoice paid',
        detail: formatCents(inv.amount_paid_cents),
      });
    } else if (inv.status === 'past_due' || inv.status === 'uncollectible') {
      events.push({
        at: inv.created_at,
        icon: 'fa-circle-exclamation',
        iconColor: 'var(--sl-text-error)',
        label: inv.status === 'past_due' ? 'Invoice past due' : 'Invoice uncollectible',
        detail: formatCents(inv.subtotal_cents),
      });
    }
  });

  if (membership.canceled_at) {
    events.push({
      at: membership.canceled_at,
      icon: 'fa-circle-minus',
      iconColor: 'var(--sl-text-warning)',
      label: membership.staff_cancel_label || 'Subscription canceled',
      detail: null,
    });
  }

  if (membership.ended_at) {
    events.push({
      at: membership.ended_at,
      icon: 'fa-circle-xmark',
      iconColor: 'var(--sl-text-quaternary)',
      label: 'Subscription ended',
      detail: null,
    });
  }

  return events.sort((a, b) => new Date(b.at) - new Date(a.at));
}

export default function ActivityTimeline() {
  const { membership } = useMembershipShowContext();
  const events = buildEvents(membership);

  return (
    <div className="team-member-card mb-3">
      <div className="team-member-card-header">
        <div className="team-member-card-header-left">
          <div className="team-member-card-title-row">
            <h2 className="team-member-card-title">Activity</h2>
          </div>
        </div>
      </div>
      <div className="team-member-card-body">
        {events.length === 0 ? (
          <p className="text-muted mb-0">No activity.</p>
        ) : (
          <div className="d-flex flex-column" style={{ gap: 16 }}>
            {events.map((event, index) => (
              <div key={index} className="d-flex align-items-start" style={{ gap: 12 }}>
                <i className={`fal ${event.icon}`} style={{ color: event.iconColor, fontSize: 18, marginTop: 2 }}></i>
                <div className="flex-grow-1">
                  <div className="font-weight-medium">
                    {event.label}
                    {event.detail && <span className="text-muted ml-2">· {event.detail}</span>}
                  </div>
                  <div className="text-muted small">{formatDateTime(event.at)}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

ActivityTimeline.propTypes = {};
